$(document).ready(function() {

	$('#speakers--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			searchSpeakers(tagValue);
		}

	});

	if ( $('.speakers--dropdown').length > 0 ) {

		$('.speakers--dropdown').selectric({
			maxHeight: 300
		}).on('change', function(e, element, selectric) {
			e.preventDefault();
			filterSpeakers();
		});

	}

	$('#speakers--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			$('.speakers--dropdown').val("").selectric('refresh');
			searchSpeakers(tagValue);
		} else {
			$('.speakers--item').removeClass('is-hiding');
			$('.speakers--dropdown').val("").selectric('refresh');
		}

	});


	$('#speakers--search-input').keyup(function( event ) {

		var tagValue = $(this).val().toLowerCase();

		if ( tagValue ) {
			$('.speakers--dropdown').val("").selectric('refresh');
			searchSpeakers(tagValue);
		} else {
			$('.speakers--item').removeClass('is-hiding');
			$('.speakers--dropdown').val("").selectric('refresh');
		}

	});

	function filterSpeakers() {

    	$('#speakers--search-input').val("");

    	var classesArray = [];

		$('.speakers--dropdown').each(function(){

			var selectClass = $(this).val();

			if (selectClass) {
				classesArray.push(selectClass);
			}

		});

		if (classesArray.length > 0) {

			var speakersItems = $('.speakers--item');

			speakersItems.each(function() {

				var shouldHide = false;
				var speakersItem  = $(this);

				$.each(classesArray, function(i,val) {

				  if ( !speakersItem.hasClass(val) ) {
				    shouldHide = true;
				  }

				});

				if (shouldHide) {
					$(this).addClass('is-hiding');
				} else {
					$(this).removeClass('is-hiding');
				};

			});

		} else {

			$('.speakers--item').removeClass('is-hiding');

		}

	}

	function searchSpeakers( value ) {

    var tagValue   = value;
    var speakersItems = $('.speakers--item');

	if (tagValue && tagValue.length > 2) {

		speakersItems.each(function() {

			var shouldHide  = false;
			var speakerItem = $(this);
    		var tags        = speakerItem.data('searchtags');

			if ( !tags.includes(tagValue) ) {
				shouldHide = true;
			}

			if (shouldHide) {
				$(this).addClass('is-hiding');
			} else {
				$(this).removeClass('is-hiding');
			};

		});

	} else {

		speakersItems.removeClass('is-hiding');

    }

  }

  ///

  $('#attendees--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			searchattendees(tagValue);
		}

	});

	if ( $('.attendees--dropdown').length > 0 ) {

		$('.attendees--dropdown').selectric({
			maxHeight: 300
		}).on('change', function(e, element, selectric) {
			e.preventDefault();
			filterattendees();
		});

	}

	$('#attendees--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			$('.attendees--dropdown').val("").selectric('refresh');
			searchattendees(tagValue);
		} else {
			$('.attendees--item').removeClass('is-hiding');
			$('.attendees--dropdown').val("").selectric('refresh');
		}

	});


	$('#attendees--search-input').keyup(function( event ) {

		var tagValue = $(this).val().toLowerCase();

		if ( tagValue ) {
			$('.attendees--dropdown').val("").selectric('refresh');
			searchattendees(tagValue);
		} else {
			$('.attendees--item').removeClass('is-hiding');
			$('.attendees--dropdown').val("").selectric('refresh');
		}

	});

	function filterattendees() {

    	$('#attendees--search-input').val("");

    	var classesArray = [];

		$('.attendees--dropdown').each(function(){

			var selectClass = $(this).val();

			if (selectClass) {
				classesArray.push(selectClass);
			}

		});

		if (classesArray.length > 0) {

			var attendeesItems = $('.attendees--item');

			attendeesItems.each(function() {

				var shouldHide = false;
				var attendeesItem  = $(this);

				$.each(classesArray, function(i,val) {

				  if ( !attendeesItem.hasClass(val) ) {
				    shouldHide = true;
				  }

				});

				if (shouldHide) {
					$(this).addClass('is-hiding');
				} else {
					$(this).removeClass('is-hiding');
				};

			});

		} else {

			$('.attendees--item').removeClass('is-hiding');

		}

	}

	function searchattendees( value ) {

    var tagValue   = value;
    var attendeesItems = $('.attendees--item');

	if (tagValue && tagValue.length > 2) {

		attendeesItems.each(function() {

			var shouldHide   = false;
			var attendeeItem = $(this);
    		var tags         = attendeeItem.data('searchtags');

			if ( !tags.includes(tagValue) ) {
				shouldHide = true;
			}

			if (shouldHide) {
				$(this).addClass('is-hiding');
			} else {
				$(this).removeClass('is-hiding');
			};

		});

	} else {

		attendeesItems.removeClass('is-hiding');

    }

  }

});
